module.exports = __webpack_public_path__ + "img/img-avatar-02.abb839ba.png";